import { put, all, call, takeLatest } from 'redux-saga/effects';
import axios, { AxiosResponse } from 'axios';
import  * as actionTypes from './actions';
import {getToken} from 'src/utils/Cookies/Cookies';

const REACT_APP_BOOK_URI : string = (`${process.env.REACT_APP_BASIC_URI}books` as string);

//TODO 북 리스트 가져오기
function* booksCallWorker () {
  const config = getToken();
  try {
    const books: AxiosResponse = yield call(() => axios.get(`${REACT_APP_BOOK_URI}?ordering=DESC`, config));
    
    yield put(actionTypes.bookSuccess(books.data));
  } catch(err:any) {
    yield put(actionTypes.bookError(err));
  }
}

//TODO 북 가져오기
function* booksCallIdWorker (payload) {
  const config = getToken()
  try {
    const bookId: AxiosResponse = yield call(() => axios.get(`${REACT_APP_BOOK_URI}/${payload.payload}`, config));
    yield put(actionTypes.bookIdSuccess(bookId.data));
  } catch(err:any) {
    yield put(actionTypes.bookIdError(err));
  }
}

//TODO 북 생성
function* bookCreateWorker({ payload }) {
  const config = getToken()
  try {
    //  yield put(actionTypes.bookCreateInit(payload));
    yield call(() => axios.post(REACT_APP_BOOK_URI,payload,config));
    
    //yield put(actionTypes.bookCreateSuccess(createBook.data));
    const books: AxiosResponse = yield call(() => axios.get(`${REACT_APP_BOOK_URI}?ordering=DESC`,config));
    yield put(actionTypes.bookSuccess(books.data));
  } catch (err:any) {
    yield put(actionTypes.bookCreateError(err));
  }
}

//TODO 북 업데이트
function* bookUpdateWorker(payload) {
  const config = getToken();
  try {
    let updateJson;
    let parameter
    if(payload.payload.image_cover){
      updateJson={image_cover:payload.payload.image_cover}
      parameter = "image-cover";
      
    }else if(payload.payload.title){
      updateJson={title:payload.payload.title}
      parameter = "title";
    }
    yield call(() => axios.patch(`${REACT_APP_BOOK_URI}/${payload.payload.id}/${parameter}`,updateJson,config));    
   
    const books: AxiosResponse = yield call(() => axios.get(`${REACT_APP_BOOK_URI}?ordering=DESC`,config));
    yield put(actionTypes.bookSuccess(books.data));
    
  } catch (err:any) {
    yield put(actionTypes.bookUpdateError(err));
  }
}

//TODO 북 제거
function* bookDeleteWorker(payload) {
  const config = getToken();
  try {
    yield call(() => axios.delete(`${REACT_APP_BOOK_URI}/${payload.payload.id}`,config));
    const books: AxiosResponse = yield call(() => axios.get(`${REACT_APP_BOOK_URI}?ordering=DESC`,config));
    yield put(actionTypes.bookSuccess(books.data));
  } catch (err:any) {
    yield put(actionTypes.bookDeleteError(err));
  }
}

export function* getBooksSaga() {
  
  yield all([
    takeLatest(actionTypes.BOOK_PAGE_INIT , booksCallWorker),
    takeLatest(actionTypes.BOOK_ID_INIT , booksCallIdWorker),
    takeLatest(actionTypes.BOOK_CREATE_INIT as any, bookCreateWorker), 
    //TODO 타입 오버라이딩 에러로 any 타입 삽입
    takeLatest(actionTypes.BOOK_UPDATE_INIT , bookUpdateWorker),
    takeLatest(actionTypes.BOOK_DELETE_INIT , bookDeleteWorker),
    
  ]); 
}